import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Servicios.css';

import serv1 from '../../assets/servicios/servicios-1.png';
import serv2 from '../../assets/servicios/servicios-2.png';
import serv3 from '../../assets/servicios/servicios-3.png';
import serv4 from '../../assets/servicios/servicios-4.png';
import serv5 from '../../assets/servicios/servicios-5.png';
import serv6 from '../../assets/servicios/servicios-6.png';

const SERVICIOS = [
  {
    id: 1,
    titulo: 'Evaluación Psicológica',
    imagen: serv1,
    resumen: 'Análisis profundo de las variables cognitivas y psicológicas del deportista.',
    descripcion: [
      'Durante este proceso se analizan variables clave como la atención, concentración, motivación, control emocional, toma de decisiones, autoconfianza, manejo del estrés competitivo y estilo de afrontamiento ante la presión. Todo esto se realiza con instrumentos y metodologías adaptadas al contexto deportivo.',
      'Al finalizar la evaluación, se entrega un informe completo y personalizado, donde se detallan todas las variables cognitivas y psicológicas del deportista, junto con recomendaciones específicas para optimizar su rendimiento en entrenamiento y competencia.',
      'Esta evaluación permite conocer al deportista en profundidad antes de comenzar el acompañamiento psicológico, asegurando que las intervenciones posteriores sean individualizadas, estratégicas y alineadas con sus objetivos deportivos.',
    ],
  },
  {
    id: 2,
    titulo: 'Acompañamiento Deportivo',
    imagen: serv2,
    resumen: 'Intervención continua para potenciar el rendimiento del deportista.',
    descripcion: [
      'A partir del informe, se intervienen las variables cognitivas y emocionales detectadas, con el objetivo de potenciar su rendimiento en entrenamiento y competencia.',
      'Se realiza un seguimiento continuo en función de sus competencias y procesos de entrenamiento, alineando el trabajo psicológico con los objetivos deportivos del jugador. Además, se mantiene comunicación constante con padres y/o apoderados para acompañar el desarrollo integral del deportista.',
      'El foco del acompañamiento es generar una evolución mental y deportiva sostenida, formando deportistas preparados para el alto rendimiento.',
    ],
  },
  {
    id: 3,
    titulo: 'Charlas',
    imagen: serv3,
    resumen: 'Charlas adaptadas al club o academia con intervención práctica.',
    descripcion: [
      'Cada charla se adapta a la realidad del club o academia, trabajando en base a las necesidades y problemáticas específicas que se presenten en el entorno deportivo.',
      'Además, se complementa con una intervención práctica posterior a la charla, orientada a generar reflexión, conciencia y herramientas aplicables a jugadores, entrenadores y apoderados.',
      'El objetivo es fortalecer la cultura psicológica del club, entregar nociones claras sobre la importancia del trabajo mental y generar un impacto real en el rendimiento y bienestar de los deportistas.',
    ],
  },
  {
    id: 4,
    titulo: 'Talleres',
    imagen: serv4,
    resumen: 'Contenidos mensuales para formar deportistas resilientes y ganadores.',
    descripcion: [
      'Mes a mes se desarrollan contenidos y intervenciones prácticas específicas para el club o academia, con el objetivo de formar deportistas más competentes, resilientes y con una mentalidad ganadora, alineados con la cultura y objetivos deportivos de la institución.',
      'Este servicio incluye la elaboración de informes psicológicos individuales de cada deportista, entregando al cuerpo técnico una visión clara y objetiva sobre las variables cognitivas y psicológicas de cada jugador, para optimizar la forma de entrenar, comunicar y desarrollar a cada deportista de manera individualizada.',
      'Los talleres buscan generar un impacto estructural en la formación deportiva, integrando la psicología como un pilar clave del rendimiento y desarrollo del club.',
    ],
  },
  {
    id: 5,
    titulo: 'Coaching Deportivo',
    imagen: serv5,
    resumen: 'Sesiones para potenciar la mentalidad competitiva en el campo.',
    descripcion: [
      'A través de sesiones de coaching, se trabajan habilidades como la toma de decisiones, concentración, control emocional, liderazgo, comunicación en cancha y mentalidad competitiva, utilizando ejercicios psicológicos integrados al entrenamiento técnico y táctico.',
      'El objetivo es que el deportista no solo entienda los conceptos psicológicos, sino que los viva y los entrene en situaciones reales de juego, logrando una transferencia directa al rendimiento competitivo.',
      'Este servicio permite potenciar la performance mental dentro del campo, fortaleciendo la confianza, la ejecución bajo presión y la coherencia entre mente, entrenamiento y competencia.',
    ],
  },
  {
    id: 6,
    titulo: 'Coaching Empresas',
    imagen: serv6,
    resumen: 'Coaching organizacional para equipos de alto rendimiento.',
    descripcion: [
      'A través de sesiones de coaching, se trabajan habilidades como la toma de decisiones, liderazgo, comunicación efectiva, gestión del estrés, trabajo en equipo, enfoque en objetivos y mentalidad de alto rendimiento, utilizando ejercicios psicológicos integrados a la dinámica diaria de la empresa.',
      'El objetivo es que las personas y equipos no solo comprendan los conceptos psicológicos, sino que los entrenen en situaciones reales de trabajo, logrando una transferencia directa a la productividad, el clima laboral y el desempeño organizacional.',
      'Además, se enfoca en el fortalecimiento de equipos de trabajo, potenciando la cohesión, confianza y coordinación entre sus miembros.',
      'Este servicio permite potenciar el rendimiento individual y colectivo, fortaleciendo la cultura organizacional y la alineación entre personas, procesos y resultados.',
    ],
  },
];

const Servicios = () => {
  const [activeService, setActiveService] = useState(null);
  const navigate = useNavigate();

  /* Bloquear scroll cuando el modal está abierto */
  useEffect(() => {
    document.body.style.overflow = activeService ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [activeService]);

  /* Cerrar con Escape */
  useEffect(() => {
    const handleEsc = e => { if (e.key === 'Escape') setActiveService(null); };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  const handleContact = () => {
    setActiveService(null);
    navigate('/contacto');
  };

  return (
    <div className="servicios-page">

      {/* ── Hero ── */}
      <div className="servicios-hero">
        <h1 className="servicios-hero__title">Nuestros Servicios</h1>
        <p className="servicios-hero__subtitle">
          Programas de psicología deportiva diseñados para potenciar el rendimiento
          integral de deportistas, clubes y organizaciones.
        </p>
      </div>

      {/* ── Grid de servicios ── */}
      <div className="servicios-grid">
        {SERVICIOS.map(servicio => (
          <div key={servicio.id} className="servicio-card">

            <div
              className="servicio-card__img-wrap"
              onClick={() => setActiveService(servicio)}
            >
              <img src={servicio.imagen} alt={servicio.titulo} className="servicio-card__img" />
              <div className="servicio-card__overlay">
                <span className="servicio-card__zoom">🔍</span>
              </div>
            </div>

            <div className="servicio-card__body">
              <h3 className="servicio-card__title">{servicio.titulo}</h3>
              <p className="servicio-card__resumen">{servicio.resumen}</p>
              <button
                className="servicio-card__btn"
                onClick={() => setActiveService(servicio)}
              >
                Ver más →
              </button>
            </div>

          </div>
        ))}
      </div>

      {/* ── Modal ── */}
      {activeService && (
        <div className="servicio-modal" onClick={() => setActiveService(null)}>
          <div className="servicio-modal__content" onClick={e => e.stopPropagation()}>

            <button
              className="servicio-modal__close"
              onClick={() => setActiveService(null)}
              aria-label="Cerrar"
            >
              ×
            </button>

            <div className="servicio-modal__image">
              <img src={activeService.imagen} alt={activeService.titulo} />
            </div>

            <div className="servicio-modal__body">
              <h2 className="servicio-modal__title">{activeService.titulo}</h2>

              <div className="servicio-modal__text">
                {activeService.descripcion.map((parrafo, i) => (
                  <p key={i}>{parrafo}</p>
                ))}
              </div>

              <button className="servicio-modal__cta" onClick={handleContact}>
                Solicitar información
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default Servicios;
